import { ChartMeasure, ChartPlugin } from '../_types'

const _baseMetricsMeasuresForSG1AssetWithInverter: ChartMeasure[] = [
  {
    slug: 'amperage',
    id: 'WS_ACT_CURR',
    representation: 'line',
    unitOfMeasurement: 'A',
    valueTransform: (value: number) => value / 10,
  },
  {
    slug: 'speed',
    id: 'WS_SET_SPD',
    representation: 'line',
    unitOfMeasurement: '%',
  },
]

const baseMetricsPluginForSG1AssetWithInverter: ChartPlugin = {
  measures: _baseMetricsMeasuresForSG1AssetWithInverter,
}

const baseMetricsWithWarnAreasPluginForSG1AssetWithInverter: ChartPlugin = {
  measures: [
    ..._baseMetricsMeasuresForSG1AssetWithInverter,
    {
      slug: 'running',
      id: 'BS_RUN',
      representation: null,
    },
  ],
  warnAreas: [{ slug: 'runningWarn', measure: 'running', fn: (value: number) => value === 0 }],
}

export { baseMetricsPluginForSG1AssetWithInverter, baseMetricsWithWarnAreasPluginForSG1AssetWithInverter }
